/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	AddPropertiesToMetadataSchema,
	CreateMetadataSchema,
	MetadataSchemaEnumeration,
	MetadataSchemaResponse,
	UpdateMetadataSchema,
	UpdateMetadataSchemaProperty,
} from '../models/index';
import {
	AddPropertiesToMetadataSchemaFromJSON,
	AddPropertiesToMetadataSchemaToJSON,
	CreateMetadataSchemaFromJSON,
	CreateMetadataSchemaToJSON,
	MetadataSchemaEnumerationFromJSON,
	MetadataSchemaEnumerationToJSON,
	MetadataSchemaResponseFromJSON,
	MetadataSchemaResponseToJSON,
	UpdateMetadataSchemaFromJSON,
	UpdateMetadataSchemaToJSON,
	UpdateMetadataSchemaPropertyFromJSON,
	UpdateMetadataSchemaPropertyToJSON,
} from '../models/index';

export interface AddPropertiesToMetadataSchemaRequest {
	encodedMetadataSchemaRID: string;
	xBffCsrf?: string;
	addPropertiesToMetadataSchema?: AddPropertiesToMetadataSchema;
}

export interface CreateMetadataSchemaRequest {
	xBffCsrf?: string;
	createMetadataSchema?: CreateMetadataSchema;
}

export interface DeleteMetadataSchemaRequest {
	encodedMetadataSchemaRID: string;
	xBffCsrf?: string;
}

export interface DeletePropertiesFromMetadataSchemaRequest {
	encodedMetadataSchemaRID: string;
	propertyKeys: Array<string>;
	xBffCsrf?: string;
}

export interface GetMetadataSchemaRequest {
	encodedMetadataSchemaRID: string;
	xBffCsrf?: string;
}

export interface ListMetadataSchemasRequest {
	xBffCsrf?: string;
	resourceType?: string;
}

export interface UpdateMetadataSchemaRequest {
	encodedMetadataSchemaRID: string;
	xBffCsrf?: string;
	updateMetadataSchema?: UpdateMetadataSchema;
}

export interface UpdateMetadataSchemaPropertyRequest {
	encodedMetadataSchemaRID: string;
	propertyKey: string;
	xBffCsrf?: string;
	updateMetadataSchemaProperty?: UpdateMetadataSchemaProperty;
}

/**
 * MetadataSchemasApi - interface
 *
 * @export
 * @interface MetadataSchemasApiInterface
 */
export interface MetadataSchemasApiInterface {
	/**
	 * Add properties to a metadata schema. Returns the complete schema with the new properties.
	 * @summary Add properties to a metadata schema
	 * @param {string} encodedMetadataSchemaRID
	 * @param {string} [xBffCsrf]
	 * @param {AddPropertiesToMetadataSchema} [addPropertiesToMetadataSchema]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	addPropertiesToMetadataSchemaRaw(
		requestParameters: AddPropertiesToMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Add properties to a metadata schema. Returns the complete schema with the new properties.
	 * Add properties to a metadata schema
	 */
	addPropertiesToMetadataSchema(
		requestParameters: AddPropertiesToMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Create a metadata schema for client organizations, client contacts or service contacts. Requires a licensed user for the account.
	 * @summary Create a metadata schema for use with client entities
	 * @param {string} [xBffCsrf]
	 * @param {CreateMetadataSchema} [createMetadataSchema] Payload to create a metadata schema for client organization, client contact or service contact.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	createMetadataSchemaRaw(
		requestParameters: CreateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<MetadataSchemaResponse>>;

	/**
	 * Create a metadata schema for client organizations, client contacts or service contacts. Requires a licensed user for the account.
	 * Create a metadata schema for use with client entities
	 */
	createMetadataSchema(
		requestParameters: CreateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<MetadataSchemaResponse>;

	/**
	 * Delete a metadata schema by RID value. Requires client_schema:delete or admin user permission. Will remove metadata from any client organizations, client contacts or service contacts that use the schema.
	 * @summary Delete a metadata schema
	 * @param {string} encodedMetadataSchemaRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	deleteMetadataSchemaRaw(
		requestParameters: DeleteMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Delete a metadata schema by RID value. Requires client_schema:delete or admin user permission. Will remove metadata from any client organizations, client contacts or service contacts that use the schema.
	 * Delete a metadata schema
	 */
	deleteMetadataSchema(
		requestParameters: DeleteMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Delete properties from a metadata schema. Returns the updated schema with the properties removed. Does not allow deleting metadata schema configured by the system.
	 * @summary Delete properties from a metadata schema
	 * @param {string} encodedMetadataSchemaRID
	 * @param {Array<string>} propertyKeys Array of property keys to delete
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	deletePropertiesFromMetadataSchemaRaw(
		requestParameters: DeletePropertiesFromMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Delete properties from a metadata schema. Returns the updated schema with the properties removed. Does not allow deleting metadata schema configured by the system.
	 * Delete properties from a metadata schema
	 */
	deletePropertiesFromMetadataSchema(
		requestParameters: DeletePropertiesFromMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Get a metadata schema by RID value. Requires client_schema:read permission.
	 * @summary Get a metadata schema
	 * @param {string} encodedMetadataSchemaRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	getMetadataSchemaRaw(
		requestParameters: GetMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<MetadataSchemaResponse>>;

	/**
	 * Get a metadata schema by RID value. Requires client_schema:read permission.
	 * Get a metadata schema
	 */
	getMetadataSchema(
		requestParameters: GetMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<MetadataSchemaResponse>;

	/**
	 * Get a list of metadata schemas for client organizations, client contacts or service contacts. Requires client_schema:read permissions.
	 * @summary Get a list of metadata schemas
	 * @param {string} [xBffCsrf]
	 * @param {string} [resourceType]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	listMetadataSchemasRaw(
		requestParameters: ListMetadataSchemasRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<MetadataSchemaEnumeration>>;

	/**
	 * Get a list of metadata schemas for client organizations, client contacts or service contacts. Requires client_schema:read permissions.
	 * Get a list of metadata schemas
	 */
	listMetadataSchemas(
		requestParameters: ListMetadataSchemasRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<MetadataSchemaEnumeration>;

	/**
	 * Update a metadata schema by RID value. Requires client_schema:modify permission.
	 * @summary Update a metadata schema
	 * @param {string} encodedMetadataSchemaRID
	 * @param {string} [xBffCsrf]
	 * @param {UpdateMetadataSchema} [updateMetadataSchema]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	updateMetadataSchemaRaw(
		requestParameters: UpdateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Update a metadata schema by RID value. Requires client_schema:modify permission.
	 * Update a metadata schema
	 */
	updateMetadataSchema(
		requestParameters: UpdateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Update property in metadata schema. Returns the complete schema with the new properties.
	 * @summary Update property in a metadata schema
	 * @param {string} encodedMetadataSchemaRID
	 * @param {string} propertyKey
	 * @param {string} [xBffCsrf]
	 * @param {UpdateMetadataSchemaProperty} [updateMetadataSchemaProperty]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof MetadataSchemasApiInterface
	 */
	updateMetadataSchemaPropertyRaw(
		requestParameters: UpdateMetadataSchemaPropertyRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Update property in metadata schema. Returns the complete schema with the new properties.
	 * Update property in a metadata schema
	 */
	updateMetadataSchemaProperty(
		requestParameters: UpdateMetadataSchemaPropertyRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;
}

/**
 *
 */
export class MetadataSchemasApi
	extends runtime.BaseAPI
	implements MetadataSchemasApiInterface
{
	/**
	 * Add properties to a metadata schema. Returns the complete schema with the new properties.
	 * Add properties to a metadata schema
	 */
	async addPropertiesToMetadataSchemaRaw(
		requestParameters: AddPropertiesToMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedMetadataSchemaRID === null ||
			requestParameters.encodedMetadataSchemaRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedMetadataSchemaRID',
				'Required parameter requestParameters.encodedMetadataSchemaRID was null or undefined when calling addPropertiesToMetadataSchema.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas/{encodedMetadataSchemaRID}/properties`.replace(
					`{${'encodedMetadataSchemaRID'}}`,
					encodeURIComponent(String(requestParameters.encodedMetadataSchemaRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: AddPropertiesToMetadataSchemaToJSON(
					requestParameters.addPropertiesToMetadataSchema
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Add properties to a metadata schema. Returns the complete schema with the new properties.
	 * Add properties to a metadata schema
	 */
	async addPropertiesToMetadataSchema(
		requestParameters: AddPropertiesToMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.addPropertiesToMetadataSchemaRaw(requestParameters, initOverrides);
	}

	/**
	 * Create a metadata schema for client organizations, client contacts or service contacts. Requires a licensed user for the account.
	 * Create a metadata schema for use with client entities
	 */
	async createMetadataSchemaRaw(
		requestParameters: CreateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<MetadataSchemaResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: CreateMetadataSchemaToJSON(requestParameters.createMetadataSchema),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			MetadataSchemaResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Create a metadata schema for client organizations, client contacts or service contacts. Requires a licensed user for the account.
	 * Create a metadata schema for use with client entities
	 */
	async createMetadataSchema(
		requestParameters: CreateMetadataSchemaRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<MetadataSchemaResponse> {
		const response = await this.createMetadataSchemaRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Delete a metadata schema by RID value. Requires client_schema:delete or admin user permission. Will remove metadata from any client organizations, client contacts or service contacts that use the schema.
	 * Delete a metadata schema
	 */
	async deleteMetadataSchemaRaw(
		requestParameters: DeleteMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedMetadataSchemaRID === null ||
			requestParameters.encodedMetadataSchemaRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedMetadataSchemaRID',
				'Required parameter requestParameters.encodedMetadataSchemaRID was null or undefined when calling deleteMetadataSchema.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas/{encodedMetadataSchemaRID}`.replace(
					`{${'encodedMetadataSchemaRID'}}`,
					encodeURIComponent(String(requestParameters.encodedMetadataSchemaRID))
				),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Delete a metadata schema by RID value. Requires client_schema:delete or admin user permission. Will remove metadata from any client organizations, client contacts or service contacts that use the schema.
	 * Delete a metadata schema
	 */
	async deleteMetadataSchema(
		requestParameters: DeleteMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.deleteMetadataSchemaRaw(requestParameters, initOverrides);
	}

	/**
	 * Delete properties from a metadata schema. Returns the updated schema with the properties removed. Does not allow deleting metadata schema configured by the system.
	 * Delete properties from a metadata schema
	 */
	async deletePropertiesFromMetadataSchemaRaw(
		requestParameters: DeletePropertiesFromMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedMetadataSchemaRID === null ||
			requestParameters.encodedMetadataSchemaRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedMetadataSchemaRID',
				'Required parameter requestParameters.encodedMetadataSchemaRID was null or undefined when calling deletePropertiesFromMetadataSchema.'
			);
		}

		if (
			requestParameters.propertyKeys === null ||
			requestParameters.propertyKeys === undefined
		) {
			throw new runtime.RequiredError(
				'propertyKeys',
				'Required parameter requestParameters.propertyKeys was null or undefined when calling deletePropertiesFromMetadataSchema.'
			);
		}

		const queryParameters: any = {};

		if (requestParameters.propertyKeys) {
			queryParameters['propertyKeys'] = requestParameters.propertyKeys;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas/{encodedMetadataSchemaRID}/properties`.replace(
					`{${'encodedMetadataSchemaRID'}}`,
					encodeURIComponent(String(requestParameters.encodedMetadataSchemaRID))
				),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Delete properties from a metadata schema. Returns the updated schema with the properties removed. Does not allow deleting metadata schema configured by the system.
	 * Delete properties from a metadata schema
	 */
	async deletePropertiesFromMetadataSchema(
		requestParameters: DeletePropertiesFromMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.deletePropertiesFromMetadataSchemaRaw(requestParameters, initOverrides);
	}

	/**
	 * Get a metadata schema by RID value. Requires client_schema:read permission.
	 * Get a metadata schema
	 */
	async getMetadataSchemaRaw(
		requestParameters: GetMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<MetadataSchemaResponse>> {
		if (
			requestParameters.encodedMetadataSchemaRID === null ||
			requestParameters.encodedMetadataSchemaRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedMetadataSchemaRID',
				'Required parameter requestParameters.encodedMetadataSchemaRID was null or undefined when calling getMetadataSchema.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas/{encodedMetadataSchemaRID}`.replace(
					`{${'encodedMetadataSchemaRID'}}`,
					encodeURIComponent(String(requestParameters.encodedMetadataSchemaRID))
				),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			MetadataSchemaResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Get a metadata schema by RID value. Requires client_schema:read permission.
	 * Get a metadata schema
	 */
	async getMetadataSchema(
		requestParameters: GetMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<MetadataSchemaResponse> {
		const response = await this.getMetadataSchemaRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Get a list of metadata schemas for client organizations, client contacts or service contacts. Requires client_schema:read permissions.
	 * Get a list of metadata schemas
	 */
	async listMetadataSchemasRaw(
		requestParameters: ListMetadataSchemasRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<MetadataSchemaEnumeration>> {
		const queryParameters: any = {};

		if (requestParameters.resourceType !== undefined) {
			queryParameters['resourceType'] = requestParameters.resourceType;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			MetadataSchemaEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Get a list of metadata schemas for client organizations, client contacts or service contacts. Requires client_schema:read permissions.
	 * Get a list of metadata schemas
	 */
	async listMetadataSchemas(
		requestParameters: ListMetadataSchemasRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<MetadataSchemaEnumeration> {
		const response = await this.listMetadataSchemasRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Update a metadata schema by RID value. Requires client_schema:modify permission.
	 * Update a metadata schema
	 */
	async updateMetadataSchemaRaw(
		requestParameters: UpdateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedMetadataSchemaRID === null ||
			requestParameters.encodedMetadataSchemaRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedMetadataSchemaRID',
				'Required parameter requestParameters.encodedMetadataSchemaRID was null or undefined when calling updateMetadataSchema.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas/{encodedMetadataSchemaRID}`.replace(
					`{${'encodedMetadataSchemaRID'}}`,
					encodeURIComponent(String(requestParameters.encodedMetadataSchemaRID))
				),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateMetadataSchemaToJSON(requestParameters.updateMetadataSchema),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Update a metadata schema by RID value. Requires client_schema:modify permission.
	 * Update a metadata schema
	 */
	async updateMetadataSchema(
		requestParameters: UpdateMetadataSchemaRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.updateMetadataSchemaRaw(requestParameters, initOverrides);
	}

	/**
	 * Update property in metadata schema. Returns the complete schema with the new properties.
	 * Update property in a metadata schema
	 */
	async updateMetadataSchemaPropertyRaw(
		requestParameters: UpdateMetadataSchemaPropertyRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedMetadataSchemaRID === null ||
			requestParameters.encodedMetadataSchemaRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedMetadataSchemaRID',
				'Required parameter requestParameters.encodedMetadataSchemaRID was null or undefined when calling updateMetadataSchemaProperty.'
			);
		}

		if (
			requestParameters.propertyKey === null ||
			requestParameters.propertyKey === undefined
		) {
			throw new runtime.RequiredError(
				'propertyKey',
				'Required parameter requestParameters.propertyKey was null or undefined when calling updateMetadataSchemaProperty.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/metadata/schemas/{encodedMetadataSchemaRID}/properties/{propertyKey}`
					.replace(
						`{${'encodedMetadataSchemaRID'}}`,
						encodeURIComponent(String(requestParameters.encodedMetadataSchemaRID))
					)
					.replace(
						`{${'propertyKey'}}`,
						encodeURIComponent(String(requestParameters.propertyKey))
					),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateMetadataSchemaPropertyToJSON(
					requestParameters.updateMetadataSchemaProperty
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Update property in metadata schema. Returns the complete schema with the new properties.
	 * Update property in a metadata schema
	 */
	async updateMetadataSchemaProperty(
		requestParameters: UpdateMetadataSchemaPropertyRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.updateMetadataSchemaPropertyRaw(requestParameters, initOverrides);
	}
}
